module.exports = __webpack_public_path__ + "img/info-affirm-background.899c5c72.png";